import { createContext } from "react";

export const FavoriteWidgetsContext = createContext();
